import { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";

const SponsoringPage = () => {
  const { t } = useContext(LanguageContext);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @media (max-width: 768px) {
        .sponsoring-container {
          padding: 10px;
        }
        .sponsoring-heading {
          font-size: 1.6rem;
        }
        .sponsoring-subheading {
          font-size: 1.2rem;
        }
        .sponsoring-paragraph {
          font-size: 0.95rem;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="sponsoring-container" style={containerStyle}>
      <h1 className="sponsoring-heading" style={headingStyle}>{t("_sponsoring.heading")}</h1>
      <p className="sponsoring-paragraph" style={paragraphStyle}>{t("_sponsoring.intro")}</p>

      <Section title={t("_sponsoring.how_heading")}>
        <p>{t("_sponsoring.how_line1")}</p>
        <ul>
          <li>{t("_sponsoring.how_point1")}</li>
          <li>{t("_sponsoring.how_point2")}</li>
          <li>{t("_sponsoring.how_point3")}</li>
          <li>{t("_sponsoring.how_point4")}</li>
        </ul>
      </Section>

      <Section title={t("_sponsoring.benefits_heading")}>
        <ul>
          <li>{t("_sponsoring.benefit1")}</li>
          <li>{t("_sponsoring.benefit2")}</li>
          <li>{t("_sponsoring.benefit3")}</li>
          <li>{t("_sponsoring.benefit4")}</li>
          <li>{t("_sponsoring.benefit5")}</li>
        </ul>
      </Section>

      <Section title={t("_sponsoring.community_heading")}>
        <p>{t("_sponsoring.community_text")}</p>
      </Section>

      <Section title={t("_sponsoring.no_shop_heading")}>
        <p>{t("_sponsoring.no_shop_text")}</p>
      </Section>

      <Section title={t("_sponsoring.who_heading")}>
        <p>{t("_sponsoring.who_text")}</p>
      </Section>

      <Section title={t("_sponsoring.how_to_heading")}>
  <p
    className="sponsoring-paragraph"
    style={paragraphStyle}
    dangerouslySetInnerHTML={{ __html: t("_sponsoring.how_to_text") }}
  />
</Section>

      <Section title={t("_sponsoring.cta_heading")}>
        <p
          className="sponsoring-paragraph"
          style={paragraphStyle}
          dangerouslySetInnerHTML={{ __html: t("_sponsoring.cta_text") }}
        />
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section style={{ marginTop: "2rem" }}>
    <h2 className="sponsoring-subheading" style={subHeadingStyle}>{title}</h2>
    <div className="sponsoring-paragraph" style={paragraphStyle}>{children}</div>
  </section>
);

const containerStyle = {
  maxWidth: "900px",
  margin: "20px auto",
  padding: "20px",
  lineHeight: "1.7",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  color: "#333"
};

const headingStyle = {
  fontSize: "2.2rem",
  fontWeight: "700",
  color: "#004080",
  marginBottom: "1rem",
  textAlign: "center",
  letterSpacing: "0.5px"
};

const subHeadingStyle = {
  fontSize: "1.4rem",
  fontWeight: "600",
  marginBottom: "0.5rem",
  color: "#004080"
};

const paragraphStyle = {
  fontSize: "1rem",
  marginBottom: "1rem"
};

export default SponsoringPage;
